import type { FaireProductEntity } from "../../entity_types/product";

export const p_ggna8davsw: FaireProductEntity = {
  token: "p_ggna8davsw",
  type: "product",
  name: "Fold-Out + Play: Farm",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/8959ddc91b86eae26c0cd7b78563054a7e583b3a1eb0f1fcef5b767bf29ac533.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b523efc5a976caf7fe822a962314c8b834a03ca2b42bf202873603b4888bdc9.jpeg",
    "https://cdn.faire.com/fastly/c515a7fde68b38e044ed3aed9e91e94acd79bcf577f676633485bd5a330caa4b.jpeg",
    "https://cdn.faire.com/fastly/6b0d0b0f2c479467078df951042d0e3005a068fe3a56f3f8abf25b255ff6e6a9.jpeg",
    "https://cdn.faire.com/fastly/de1f4b6f57f000049da47e59c228c9cc6309ab5cc6457ae7c33a252f61e3b5db.jpeg"
  ],
  priceDollars: 12.5,
  description: "A spectacular fold-out book that transforms into a beautiful 3D farm with stand-up characters, animals, and farm accessories, plus stickers!\n\nThis ingenious fold-out farm includes a barn and outdoor area, durable and adorable characters and animals that slot into stands, plus 3D farm equipment and other accessories as well as stickers to decorate the barn inside and out.\n\nRead the short rhyming story or make up your own for hours of play. Store the press-out pieces in the sturdy drawer when you are done playing and take the book with you wherever you go!",
  tags: [],
  msrpDollars: 24.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:07:08.402Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
